export const cardLockAndReplace = {
    /** Displays card lock and replace description with fees if value is true */
    showFees: false,
};
